var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.16626H18V3.16626C18 2.61626 17.55 2.16626 17 2.16626C16.45 2.16626 16 2.61626 16 3.16626V4.16626H8V3.16626C8 2.61626 7.55 2.16626 7 2.16626C6.45 2.16626 6 2.61626 6 3.16626V4.16626H5C3.89 4.16626 3.01 5.06626 3.01 6.16626L3 20.1663C3 21.2663 3.89 22.1663 5 22.1663H19C20.1 22.1663 21 21.2663 21 20.1663V6.16626C21 5.06626 20.1 4.16626 19 4.16626ZM19 19.1663C19 19.7163 18.55 20.1663 18 20.1663H6C5.45 20.1663 5 19.7163 5 19.1663V9.16626H19V19.1663ZM7 11.1663H9V13.1663H7V11.1663ZM11 11.1663H13V13.1663H11V11.1663ZM15 11.1663H17V13.1663H15V11.1663Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.81eac3bd4776e2c19203489a84ac95df.svg";
export { ForwardRef as ReactComponent };